// Mirrors apps/ui's adaptBasePath. The old app ran this in its App useEffect, but the
// shell consumes ui_old as a federation (libs/components) and never mounts that App —
// so the shell must own this logic. When loaded outside its deploy base (root '/', or an
// env-prefixed path like /beta/... missing the base), returns the path with the base
// prepended so the router's `basename` matches. Unchanged when already under the base.
export const adaptBasePath = (pathname, basePath) => {
  if (pathname.startsWith(basePath)) return pathname;
  // '/argos' -> '' ; '/beta/argos' -> '/beta'  (env prefix to strip so it isn't duplicated)
  const envPrefix = basePath.replace(/\/[^/]+$/, '');
  return `${basePath}${pathname.replace(envPrefix, '')}`;
};
